"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("../models");
const request_1 = require("../requests/request");
const errors_1 = require("../errors");
class LoginUserError extends Error {
    constructor(type, underlyingError) {
        super('User Login Error');
        this.type = type;
        this.underlyingError = underlyingError;
    }
}
exports.LoginUserError = LoginUserError;
var LoginUserErrorType;
(function (LoginUserErrorType) {
    LoginUserErrorType[LoginUserErrorType["invalidLogin"] = 0] = "invalidLogin";
    LoginUserErrorType[LoginUserErrorType["userNotFound"] = 1] = "userNotFound";
    LoginUserErrorType[LoginUserErrorType["unknownError"] = 2] = "unknownError";
})(LoginUserErrorType = exports.LoginUserErrorType || (exports.LoginUserErrorType = {}));
class API {
    /**
     * Login the user
     * @param {string} email
     * @param {string} password
     * @returns {Promise<User>} The Promise contains either a user or a LoginUserError if rejected
     */
    static login(email, password, device) {
        let apiRequest = new request_1.BasicRequest('/login', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2, undefined, {
            email: email,
            password: password,
            device: device
        });
        return apiRequest.send(models_1.Device).then((response) => {
            return response.data;
        }).catch((error) => {
            switch (error.type) {
                case errors_1.APIErrorType.InvalidParameters:
                    throw new LoginUserError(LoginUserErrorType.invalidLogin, error);
                case errors_1.APIErrorType.InvalidLogin:
                    throw new LoginUserError(LoginUserErrorType.invalidLogin, error);
                case errors_1.APIErrorType.ResourceNotFound:
                    throw new LoginUserError(LoginUserErrorType.userNotFound, error);
                default:
                    throw new LoginUserError(LoginUserErrorType.unknownError, error);
            }
        });
    }
    /**
     * Registers a new facebook user with the provided data
     * @param {string} facebook_token
     * @returns {Promise<User>} The Promise contains either a user or a LoginUserError if rejected
     */
    static authenticateFacebookUser(facebook_token, device) {
        let apiRequest = new request_1.BasicRequest('/login/facebook', request_1.HTTPMethod.POST, request_1.APIVersion.v1_2, undefined, {
            "facebook_token": facebook_token,
            "device": device
        });
        return apiRequest.send(models_1.Device).then((response) => {
            return response.data;
        }).catch((error) => {
            switch (error.type) {
                case errors_1.APIErrorType.InvalidParameters:
                    throw new LoginUserError(LoginUserErrorType.invalidLogin, error);
                case errors_1.APIErrorType.InvalidLogin:
                    throw new LoginUserError(LoginUserErrorType.invalidLogin, error);
                case errors_1.APIErrorType.ResourceNotFound:
                    throw new LoginUserError(LoginUserErrorType.userNotFound, error);
                default:
                    throw new LoginUserError(LoginUserErrorType.unknownError, error);
            }
        });
    }
}
exports.API = API;
